import styled from 'styled-components';

import { c00EE91, cFF005C } from '#/colors';

interface Props {
  className?: string;
  /** width of the indication, primary and secondary bar width will be based on this value */
  width: string;
  primary?: string;
  secondary?: string;
  side: 'BUY' | 'SELL';
}

/**
 * Volume indication component containing of primary and secondary "bars"
 *  - 'primary' bar can be used to indicate "own" volume for a given entry
 *  - 'secondary' bar can represent "running sum" volume of all the volumes before
 */
export default function VolumeIndication(props: Props) {
  const { className, width, secondary = '0', primary = '0', side } = props;

  return (
    <Container width={width} className={className}>
      <Indication side={side} width={`${primary}%`} />
      <Indication side={side} width={`${secondary}%`} />
    </Container>
  );
}

const Container = styled.div<{ width: string }>`
  z-index: -1;
  top: 0;
  right: 0;
  height: 100%;
  width: ${({ width }) => width};
  position: absolute;
  display: flex;
  align-items: center;
`;

export const Indication = styled.div.attrs<{ width: string }>((props) => ({
  // `width` is being used as style because it changes
  // frequently and would generate hundreds of classes.
  style: { width: props.width },
}))<{ width: string; side: 'BUY' | 'SELL' }>`
  position: absolute;
  right: 0;
  height: 95%;
  opacity: 0.2;
  background-color: ${({ side }) => (side === 'BUY' ? c00EE91 : cFF005C)};
`;
